import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotificacionComponent } from './notificacion.component';
import { ContactoListaComponent } from './contacto/contacto-lista/contacto-lista.component';
import { ContactoVentanaComponent } from './contacto/contacto-ventana/contacto-ventana.component';
import { EnviarCorreoComponent } from './procesos/enviar-correo/enviar-correo.component';
import { HistorialNotificacionVentanaComponent } from './historial-notificacion/historial-notificacion-ventana/historial-notificacion-ventana.component';
import { HistorialNotificacionListaComponent } from './historial-notificacion/historial-notificacion-lista/historial-notificacion-lista.component';
import { InformeNotificacionComponent } from './reportes/informe-notificacion/informe-notificacion.component';
import { ImportarContactoComponent } from './procesos/importar-contacto/importar-contacto.component';
import { EnvioMensajeComponent } from './procesos/envio-mensaje/envio-mensaje.component';
import { WhatsappConversationListaComponent } from './whatsapp-conversation/whatsapp-conversation-lista/whatsapp-conversation-lista.component';
import { WhatsappConversationVentanaComponent } from './whatsapp-conversation/whatsapp-conversation-ventana/whatsapp-conversation-ventana.component';
import { WhatsappTemplateListaComponent } from './whatsapp-template/whatsapp-template-lista/whatsapp-template-lista.component';
import { WhatsappTemplateVentanaComponent } from './whatsapp-template/whatsapp-template-ventana/whatsapp-template-ventana.component';





@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '', component: NotificacionComponent
                ,
                children: [
            { path: '', redirectTo: 'contacto', pathMatch: 'full' },
                    { path: 'contactos', component: ContactoListaComponent },
                    { path: 'contactos/:id', component: ContactoVentanaComponent },
                    { path: 'historial-notificaciones', component: HistorialNotificacionListaComponent },
                    { path: 'historial-notificaciones/:id', component: HistorialNotificacionVentanaComponent },
                    { path: 'whatsapp-inbox', component: WhatsappConversationListaComponent },
                    { path: 'whatsapp-inbox/:id', component: WhatsappConversationVentanaComponent },
                    { path: 'whatsapp-templates', component: WhatsappTemplateListaComponent },
                    { path: 'whatsapp-templates/:id', component: WhatsappTemplateVentanaComponent },
                       //procesos
                    { path: 'procesos/enviar-correo', component: EnviarCorreoComponent },
                    { path: 'procesos/procesar-contacto', component: ImportarContactoComponent },
                    { path: 'procesos/enviar-mensaje', component: EnvioMensajeComponent },
                    //reportes
                    { path: 'reportes/informe-notificacion', component: InformeNotificacionComponent },
                    
                ]
            },
            {path: '**', redirectTo: '/notfound'},
        ])
    ],
    exports: [RouterModule]
})
export class NotificacionRoutingModule { }
